const ArticleIcon = ({className}: {className?:string;}) => {
  return (
<svg className={className} width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
<path opacity="0.3" d="M5.83301 5.83325V22.1666H22.1663V5.83325H5.83301ZM16.333 19.8333H8.16634V17.4999H16.333V19.8333ZM19.833 15.1666H8.16634V12.8333H19.833V15.1666ZM19.833 10.4999H8.16634V8.16659H19.833V10.4999Z" fill="#6F6F6F"/>
<path d="M22.1667 3.5H5.83333C4.55 3.5 3.5 4.55 3.5 5.83333V22.1667C3.5 23.45 4.55 24.5 5.83333 24.5H22.1667C23.45 24.5 24.5 23.45 24.5 22.1667V5.83333C24.5 4.55 23.45 3.5 22.1667 3.5ZM22.1667 22.1667H5.83333V5.83333H22.1667V22.1667ZM19.8333 15.1667H8.16667V12.8333H19.8333V15.1667ZM19.8333 10.5H8.16667V8.16667H19.8333V10.5ZM16.3333 19.8333H8.16667V17.5H16.3333V19.8333Z" fill="#6F6F6F"/>
</svg>
  )
}

export default ArticleIcon